import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_LOAN_REDUX]'; // eslint-disable-line

const functionDefinitions = {

    /*---------- clearLoanRedux --------*/
    clearLoanReduxState: [],

    /*---------- updateOldLoan --------*/
    requestUpdateOldLoan: ['loan', 'propertyId', 'parentId', 'parentType'],
    updateOldLoanSuccess: ['oldLoanResponse'],
    updateOldLoanFailure: ['oldLoanError'],

    /*---------- oldLoanTakeOver --------*/
    requestOldLoanTakeOver: ['loan', 'propertyId', 'parentId', 'parentType'],
    oldLoanTakeOverSuccess: ['oldLoanResponse'],
    oldLoanTakeOverFailure: ['oldLoanError'],

    /*---------- updateILSLoan --------*/
    requestUpdateILSLoan: ['ILSLoan'],
    updateILSLoanSuccess: ['ILSLoanResponse'],
    updateILSLoanFailure: ['ILSLoanError'],

    /*---------- removeTakenLoan --------*/
    requestRemoveTakenLoan: ['loanId', 'propertyId', 'parentId', 'parentType'],
    removeTakenLoanSuccess: ['oldLoanResponse'],
    removeTakenLoanFailure: ['oldLoanError'],

    /*---------- updateNewLoan --------*/
    requestUpdateNewLoan: ['loan'],
    updateNewLoanSuccess: ['newLoanResponse'],
    updateNewLoanFailure: ['newLoanError'],

    /*---------- removeNewLoan --------*/
    requestRemoveNewLoan: ['loanId', 'parentId', 'parentType'],
    removeNewLoanSuccess: ['newLoanResponse'],
    removeNewLoanFailure: ['newLoanError'],

    /*---------- updateLoanTitle --------*/
    requestUpdateLoanTitle: ['refId', 'refType', 'title', 'loanType'],
    updateLoanTitleSuccess: ['loanResponse'],
    updateLoanTitleFailure: ['loanError'],

    /*---------- updateBond --------*/
    requestUpdateBond: ['loan'],
    updateBondSuccess: ['bondResponse'],
    updateBondFailure: ['bondError'],

    /*---------- removeBond --------*/
    requestRemoveBond: ['loanId', 'parentId', 'parentType'],
    removeBondSuccess: ['bondResponse'],
    removeBondFailure: ['bondError'],

    /*---------- updateLoanDate --------*/
    requestUpdateLoanDate: ['refId', 'refType', 'contractDate', 'contractDeedDue', 'transferDate', 'previousDeedDueDate','transferDateText'],
    updateLoanDateSuccess: ['updateLoanDateResponse'],
    updateLoanDateFailure: ['updateLoanDateError'],

    /*---------- removeILSLoan --------*/

    requestRemoveILSLoan: ['loanId', 'parentId', 'parentType'],
    removeILSLoanSuccess: ['ILSLoanResponse'],
    removeILSLoanFailure: ['ILSLoanError'],

};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaLoanTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaLoanInitState = {
    oldLoanFetching: false,
    oldLoanResponse: null,
    oldLoanError: null,
};

export const INITIAL_STATE = Immutable(SagaLoanInitState);

/* ------------- Reducers ------------- */

/*---------- clearLoanReduxState --------*/
export const clearLoanReduxState = (state) => {
    return state.merge(
        {
            oldLoanFetching: false,
            oldLoanResponse: null,
            oldLoanError: null,
            ILSLoanFetching: false,
            ILSLoanResponse: null,
            ILSLoanError: null,
            newLoanFetching: false,
            newLoanResponse: null,
            newLoanError: null,
            updateLoanTitleFetching: false,
            loanResponse: null,
            loanError: null,
            bondFetching: false,
            bondResponse: null,
            bondError: null,
            updateLoanDateFetching: false,
            updateLoanDateResponse: null,
            updateLoanDateError: null,
        });
};

/*---------- updateOldLoan --------*/
export const requestUpdateOldLoan = (state, action) => {
    return state.merge(
        {
            oldLoanFetching: true,
            loan: action.loan,
            propertyId: action.propertyId,
            parentId: action.parentId,
            parentType: action.parentType,
            oldLoanResponse: null,
            oldLoanError: null,
        });
};
export const updateOldLoanSuccess = (state, action) => {
    return state.merge(
        {
            oldLoanFetching: false,
            oldLoanResponse: action.oldLoanResponse,
        });
};
export const updateOldLoanFailure = (state, action) => {
    return state.merge(
        {
            oldLoanFetching: false,
            oldLoanError: action.oldLoanError,
        });
};

/*---------- oldLoanTakeOver --------*/
export const requestOldLoanTakeOver = (state, action) => {
    return state.merge(
        {
            oldLoanFetching: true,
            loan: action.loan,
            propertyId: action.propertyId,
            parentId: action.parentId,
            parentType: action.parentType,
            oldLoanResponse: null,
            oldLoanError: null,
        });
};
export const oldLoanTakeOverSuccess = (state, action) => {
    return state.merge(
        {
            oldLoanFetching: false,
            oldLoanResponse: action.oldLoanResponse,
        });
};
export const oldLoanTakeOverFailure = (state, action) => {
    return state.merge(
        {
            oldLoanFetching: false,
            oldLoanError: action.oldLoanError,
        });
};

/*---------- removeTakenLoan --------*/
export const requestRemoveTakenLoan = (state, action) => {
    return state.merge(
        {
            oldLoanFetching: true,
            loanId: action.loanId,
            propertyId: action.propertyId,
            parentId: action.parentId,
            parentType: action.parentType,
            oldLoanResponse: null,
            oldLoanError: null,
        });
};
export const removeTakenLoanSuccess = (state, action) => {
    return state.merge(
        {
            oldLoanFetching: false,
            oldLoanResponse: action.oldLoanResponse,
        });
};
export const removeTakenLoanFailure = (state, action) => {
    return state.merge(
        {
            oldLoanFetching: false,
            oldLoanError: action.oldLoanError,
        });
};

/*---------- updateILSLoan --------*/
export const requestUpdateILSLoan = (state, action) => {
    return state.merge(
        {
            ILSLoanFetching: true,
            ILSLoan: action.ILSLoan,
            ILSLoanResponse: null,
            ILSLoanError: null,
        });
};
export const updateILSLoanSuccess = (state, action) => {
    return state.merge(
        {
            ILSLoanFetching: false,
            ILSLoanResponse: action.ILSLoanResponse,
        });
};
export const updateILSLoanFailure = (state, action) => {
    return state.merge(
        {
            ILSLoanFetching: false,
            ILSLoanError: action.ILSLoanError,
        });
};

/*---------- updateNewLoan --------*/
export const requestUpdateNewLoan = (state, action) => {
    return state.merge(
        {
            newLoanFetching: true,
            loan: action.loan,
            newLoanResponse: null,
            newLoanError: null,
        });
};
export const updateNewLoanSuccess = (state, action) => {
    return state.merge(
        {
            newLoanFetching: false,
            newLoanResponse: action.newLoanResponse,
        });
};
export const updateNewLoanFailure = (state, action) => {
    return state.merge(
        {
            newLoanFetching: false,
            newLoanError: action.newLoanError,
        });
};

/*---------- removeNewLoan --------*/
export const requestRemoveNewLoan = (state, action) => {
    return state.merge(
        {
            newLoanFetching: true,
            loanId: action.loanId,
            parentId: action.parentId,
            parentType: action.parentType,
            newLoanResponse: null,
            newLoanError: null,
        });
};
export const removeNewLoanSuccess = (state, action) => {
    return state.merge(
        {
            newLoanFetching: false,
            newLoanResponse: action.newLoanResponse,
        });
};
export const removeNewLoanFailure = (state, action) => {
    return state.merge(
        {
            newLoanFetching: false,
            newLoanError: action.newLoanError,
        });
};

/*---------- updateLoanTitle --------*/
export const requestUpdateLoanTitle = (state, action) => {
    return state.merge(
        {
            updateLoanTitleFetching: true,
            refId: action.refId,
            refType: action.refType,
            title: action.title,
            loanType: action.loanType,
            loanResponse: null,
            loanError: null,
        });
};
export const updateLoanTitleSuccess = (state, action) => {
    return state.merge(
        {
            updateLoanTitleFetching: false,
            loanResponse: action.loanResponse,
        });
};
export const updateLoanTitleFailure = (state, action) => {
    return state.merge(
        {
            updateLoanTitleFetching: false,
            loanError: action.loanError,
        });
};

/*---------- updateBond --------*/
export const requestUpdateBond = (state, action) => {
    return state.merge(
        {
            bondFetching: true,
            loan: action.loan,
            bondResponse: null,
            bondError: null,
        });
};
export const updateBondSuccess = (state, action) => {
    return state.merge(
        {
            bondFetching: false,
            bondResponse: action.bondResponse,
        });
};
export const updateBondFailure = (state, action) => {
    return state.merge(
        {
            bondFetching: false,
            bondError: action.bondError,
        });
};

/*---------- removeBond --------*/
export const requestRemoveBond = (state, action) => {
    return state.merge(
        {
            removeBondFetching: true,
            loanId: action.loanId,
            parentId: action.parentId,
            parentType: action.parentType,
            bondResponse: null,
            bondError: null,
        });
};
export const removeBondSuccess = (state, action) => {
    return state.merge(
        {
            removeBondFetching: false,
            bondResponse: action.bondResponse,
        });
};
export const removeBondFailure = (state, action) => {
    return state.merge(
        {
            removeBondFetching: false,
            bondError: action.bondError,
        });
};

/*---------- updateLoanDate --------*/
export const requestUpdateLoanDate = (state, action) => {
    return state.merge(
        {
            updateLoanDateFetching: true,
            refId: action.refId,
            refType: action.refType,
            contractDate: action.contractDate,
            contractDeedDue: action.contractDeedDue,
            transferDate: action.transferDate,
            previousDeedDueDate: action.previousDeedDueDate,
            transferDateText:action.transferDateText,
            updateLoanDateResponse: null,
            updateLoanDateError: null,
        });
};
export const updateLoanDateSuccess = (state, action) => {
    return state.merge(
        {
            updateLoanDateFetching: false,
            updateLoanDateResponse: action.updateLoanDateResponse,
        });
};
export const updateLoanDateFailure = (state, action) => {
    return state.merge(
        {
            updateLoanDateFetching: false,
            updateLoanDateError: action.updateLoanDateError,
        });
};

/*---------- removeILSLoan --------*/


export const requestRemoveILSLoan = (state, action) => {
    return state.merge(
        {
            removeILSLoanFetching: true,
            loanId: action.loanId,
            parentId: action.parentId,
            parentType: action.parentType,
            ILSLoanError: null,
            ILSLoanResponse: null

        });
};
export const removeILSLoanSuccess = (state, action) => {
    return state.merge(
        {
            removeILSLoanFetching: false,
            ILSLoanResponse: action.ILSLoanResponse,

        });
};
export const removeILSLoanFailure = (state, action) => {
    return state.merge(
        {
            removeILSLoanFetching: false,
            ILSLoanError: action.ILSLoanError,

        });
};


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {

    /*---------- clarLoanRedux --------*/
    [Types.CLEAR_LOAN_REDUX_STATE]: clearLoanReduxState,

    /*---------- updateOldLoan --------*/
    [Types.REQUEST_UPDATE_OLD_LOAN]: requestUpdateOldLoan,
    [Types.UPDATE_OLD_LOAN_SUCCESS]: updateOldLoanSuccess,
    [Types.UPDATE_OLD_LOAN_FAILURE]: updateOldLoanFailure,

    /*---------- oldLoanTakeOver --------*/
    [Types.REQUEST_OLD_LOAN_TAKE_OVER]: requestOldLoanTakeOver,
    [Types.OLD_LOAN_TAKE_OVER_SUCCESS]: oldLoanTakeOverSuccess,
    [Types.OLD_LOAN_TAKE_OVER_FAILURE]: oldLoanTakeOverFailure,

    /*---------- updateILSLoan --------*/
    [Types.REQUEST_UPDATE_I_L_S_LOAN]: requestUpdateILSLoan,
    [Types.UPDATE_I_L_S_LOAN_SUCCESS]: updateILSLoanSuccess,
    [Types.UPDATE_I_L_S_LOAN_FAILURE]: updateILSLoanFailure,

    /*---------- removeTakenLoan --------*/
    [Types.REQUEST_REMOVE_TAKEN_LOAN]: requestRemoveTakenLoan,
    [Types.REMOVE_TAKEN_LOAN_SUCCESS]: removeTakenLoanSuccess,
    [Types.REMOVE_TAKEN_LOAN_FAILURE]: removeTakenLoanFailure,

    /*---------- updateNewLoan --------*/
    [Types.REQUEST_UPDATE_NEW_LOAN]: requestUpdateNewLoan,
    [Types.UPDATE_NEW_LOAN_SUCCESS]: updateNewLoanSuccess,
    [Types.UPDATE_NEW_LOAN_FAILURE]: updateNewLoanFailure,

    /*---------- removeNewLoan --------*/
    [Types.REQUEST_REMOVE_NEW_LOAN]: requestRemoveNewLoan,
    [Types.REMOVE_NEW_LOAN_SUCCESS]: removeNewLoanSuccess,
    [Types.REMOVE_NEW_LOAN_FAILURE]: removeNewLoanFailure,

    /*---------- updateLoanTitle --------*/
    [Types.REQUEST_UPDATE_LOAN_TITLE]: requestUpdateLoanTitle,
    [Types.UPDATE_LOAN_TITLE_SUCCESS]: updateLoanTitleSuccess,
    [Types.UPDATE_LOAN_TITLE_FAILURE]: updateLoanTitleFailure,

    /*---------- updateBond --------*/
    [Types.REQUEST_UPDATE_BOND]: requestUpdateBond,
    [Types.UPDATE_BOND_SUCCESS]: updateBondSuccess,
    [Types.UPDATE_BOND_FAILURE]: updateBondFailure,

    /*---------- removeBond --------*/
    [Types.REQUEST_REMOVE_BOND]: requestRemoveBond,
    [Types.REMOVE_BOND_SUCCESS]: removeBondSuccess,
    [Types.REMOVE_BOND_FAILURE]: removeBondFailure,

    /*---------- updateLoanDate --------*/
    [Types.REQUEST_UPDATE_LOAN_DATE]: requestUpdateLoanDate,
    [Types.UPDATE_LOAN_DATE_SUCCESS]: updateLoanDateSuccess,
    [Types.UPDATE_LOAN_DATE_FAILURE]: updateLoanDateFailure,

    /*---------- removeILSLoan --------*/

    [Types.REQUEST_REMOVE_I_L_S_LOAN]: requestRemoveILSLoan,
    [Types.REMOVE_I_L_S_LOAN_SUCCESS]: removeILSLoanSuccess,
    [Types.REMOVE_I_L_S_LOAN_FAILURE]: removeILSLoanFailure,

});



// WEBPACK FOOTER //
// ./src/redux/sagaLoan/sagaLoanRedux.ts